import "./styles.scss"

const ReportFrame = (props) => {
  const {
    url,
    title
  } = props;

  console.log(url);

  return <div className='report-frame-container'>
    <iframe src={url} title={title} className='report-iframe'/>
  </div>
}

export default ReportFrame;